/**
 * Mobile PDP “large” (ODX touch product-modal): close zoom on hamburger only.
 * Do not call hide() synchronously on pointerdown inside #menu-drawer links — WebKit can retarget the
 * subsequent click to the product gallery under the drawer (nav “opens” the large image instead).
 *
 * Debug: when `window.odxMobileZoomDebugLog` exists (variant gallery HUD), logs nav pointerdown/click
 * with `source: 'odx-nav-coexist'` for retarget + stacking diagnosis.
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  function isMobileViewport() {
    try {
      return window.matchMedia(MOBILE_MQ).matches;
    } catch (_e) {
      return false;
    }
  }

  function odxNavZoomDbg(payload) {
    try {
      if (typeof window.odxMobileZoomDebugLog === 'function') {
        window.odxMobileZoomDebugLog(Object.assign({ source: 'odx-nav-coexist' }, payload));
      }
    } catch (_e) {}
  }

  function countTouchZoomOpen() {
    return document.querySelectorAll('product-modal.product-media-modal--touch-active[open]').length;
  }

  function odxCloseTouchZoomModals() {
    document.querySelectorAll('product-modal.product-media-modal--touch-active[open]').forEach(function (el) {
      if (typeof el.hide === 'function') el.hide();
    });
  }

  function onDocumentPointerDownCapture(e) {
    if (!isMobileViewport()) return;
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details || !e.target || !details.contains(e.target)) return;

    var drawer = document.getElementById('menu-drawer');
    if (drawer && drawer.contains(e.target)) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (link) {
        odxNavZoomDbg({
          event: 'nav-drawer-link-ptrdown',
          href: (link.getAttribute('href') || '').trim(),
          label: (link.textContent || '').trim().slice(0, 48),
          touchModalOpen: countTouchZoomOpen() > 0
        });
      }
    }

    var summary = details.querySelector(':scope > summary');
    if (summary && (summary === e.target || summary.contains(e.target))) {
      odxNavZoomDbg({
        event: 'nav-hamburger-ptrdown',
        touchModalOpen: countTouchZoomOpen() > 0
      });
      odxCloseTouchZoomModals();
    }
  }

  function onDrawerLinkClickCapture(e) {
    if (!isMobileViewport()) return;
    var drawer = document.getElementById('menu-drawer');
    if (!drawer || !e.target || !drawer.contains(e.target)) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = (a.getAttribute('href') || '').trim();
    if (!href || href === '#') return;
    if (/^javascript:/i.test(href)) return;
    odxNavZoomDbg({
      event: 'nav-drawer-link-click',
      href: href,
      label: (a.textContent || '').trim().slice(0, 48),
      touchModalOpen: countTouchZoomOpen() > 0
    });
  }

  function bind() {
    document.addEventListener('pointerdown', onDocumentPointerDownCapture, true);
    document.addEventListener('click', onDrawerLinkClickCapture, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
